import { CalendarClock } from "lucide-react";

const gb = (mb) => (mb >= 1000 ? `${(mb / 1000).toFixed(mb % 1000 ? 1 : 0)}GB` : `${mb}MB`);

export const LoadedBundles = ({ redemptions }) => {
  const loaded = redemptions.filter((r) => r.status === "redeemed" && r.expires_at);
  if (!loaded.length) return null;
  return (
    <div className="mt-4 space-y-2" data-testid="loaded-bundles">
      <div className="text-[11px] text-neutral-400 font-medium">Loaded bundles</div>
      {loaded.map((r) => {
        const exp = new Date(r.expires_at);
        const left = Math.ceil((exp - Date.now()) / 864e5);
        const total = r.validity_days || 60;
        const pct = Math.max(0, Math.min(left / total, 1)) * 100;
        const expired = left <= 0;
        const soon = !expired && left <= 7;
        const tone = expired ? "#6b6b75" : soon ? "#FF9F0A" : "#32D74B";
        return (
          <div key={r.id} className="rounded-2xl bg-white/[0.04] border border-white/[0.06] px-3 py-2.5" data-testid={`bundle-${r.id}`}>
            <div className="flex items-center justify-between text-xs">
              <span className="text-white font-medium">{gb(r.mb)} <span className="text-neutral-500 font-normal">→ {r.megatel_number || ""}</span></span>
              <span className="font-semibold tabular-nums" style={{ color: tone }} data-testid={`bundle-days-left-${r.id}`}>
                {expired ? "Expired" : `${left} day${left === 1 ? "" : "s"} left`}
              </span>
            </div>
            <div className="mt-2 h-1.5 rounded-full bg-white/[0.06] overflow-hidden">
              <div className="h-full rounded-full transition-[width] duration-500" style={{ width: `${pct}%`, background: tone }} />
            </div>
            <div className="mt-1.5 flex items-center gap-1 text-[10px] text-neutral-500" data-testid={`bundle-valid-until-${r.id}`}>
              <CalendarClock className="w-3 h-3" />
              {expired ? "Expired on" : "Valid until"} {exp.toLocaleDateString([], { day: "numeric", month: "short", year: "numeric" })}
            </div>
          </div>
        );
      })}
    </div>
  );
};
